import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getExerciseMapping, saveExerciseMapping, deleteExercisesMapping, saveExerciseMappingToProd } from '../../actions';


class Exercise extends Component {

  initState = {
    search: [],
    present_name: '',
    name: '',
    type: '',
    difficulty:'',
    front: 'TRAINEE',
    score: false,
    bars: false,
    skeleton: false,
    instructions: {
      intro:'',
      trainer_tips:''
    },
    checked:[],
    oldName: null,
    _id: null
  }

  state = {
    ...this.initState,
    exercisesAll: [],
    exercises: [],
    exercisePresentName: []
  }

  componentWillMount = () => {
    this.props.getExerciseMapping()
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.exerciseMapping) {
      this.setState({
        exercisesAll: nextProps.exerciseMapping,
        exercises: nextProps.exerciseMapping,
        exercisePresentName: nextProps.exerciseMapping.map(exercise => exercise.present_name).sort((a,b) => a < b ? a : b)
      })
    } 

    if (nextProps.deleteExercises) {
      this.props.getExerciseMapping();
    }
  }

  handleChange = (evt, field) => {
    const name = evt.target.name;
    let value = evt.target.value;
    
    if(name === 'present_name') {
      value = value.toUpperCase();
    } 
    if(name === 'present_name' && this.state.oldName === null) {
      let present_name = this.state.present_name
      this.setState({
        ...this.state,
        oldName: present_name
      })
    } 
    
    if(Object.keys(this.state.instructions).indexOf(name) !== -1 ){
      this.setState({
        ...this.state,
        instructions: { ...this.state.instructions, [name]: value },
      });
    } else {
      this.setState({
        ...this.state,
        [name]: value
      });
    }

    if(evt.target.name === 'search') {
      this.setState({
        exercises: this.state.exercisesAll.filter(exercise => (exercise && exercise.present_name && exercise.present_name.includes(value.toUpperCase())) || 
        (exercise && exercise.name && exercise.name.includes(value)))
      })
    }

  }

  submitForm = async (e) => {
    e.preventDefault();
    await this.props.saveExerciseMapping(this.state);

    this.setState({
      ...this.initState
    })
    this.props.getExerciseMapping();
  }

  edit = (exercises) => {
    if (this.state.checked.length >= 1) {
      this.setState({...this.initState})
    } else {
      this.setState({
        _id: exercises._id,
        present_name: exercises.present_name,
        type: exercises.type,
        difficulty: exercises.difficulty || '',
        name: exercises.name,
        oldName: exercises.present_name,
        front: exercises.front,
        score: exercises.score,
        bars:exercises.bars,
        skeleton: exercises.skeleton,
        points: exercises.points || 0,
        instructions: {
          intro: exercises.instructions ? exercises.instructions.intro : '',
          trainer_tips: exercises.instructions? exercises.instructions.trainer_tips : ''
        }
      })
    }
  }

  deleteExercises = (e) => {
    e.preventDefault();
    this.props.deleteExercisesMapping(this.state.checked);
    this.setState({...this.initState})
  }

  renderExercises = () => (
    this.state.exercises.sort((a,b) => (a.present_name > b.present_name) ? 1 : ((b.present_name > a.present_name) ? -1 : 0))
    .map((exercise, i) => {
      return <div key={i} className="inline-row inline-row-motivation" onClick={()=> this.edit(exercise)}>
         <div className="column column-checkbox" style={{border: 'none'}}><input  className="checkbox" type="checkbox" name="workoutCheckbox" 
          checked={this.state.checked.indexOf(exercise._id) === -1 ? false : true }
          onChange={() => this.checkboxClick(exercise)}/></div>
        <div className="column-motivation hover">{exercise.present_name}</div>
      </div>
    }) 
  )
  
  renderSelect = (options) => (
    options.map((lable, i) => {
      return <option key={i} value={lable}> {lable} </option>
    })
  )

  checkboxClick = (exercise) => {
    let index = this.state.checked.indexOf(exercise._id);
    if(index !== -1) {
      let checked = this.state.checked.filter(checkedW => checkedW !== exercise._id)
      
      this.setState({
        checked
      })
    } else {
      this.setState({
        checked: [...this.state.checked, exercise._id]
      })
    }
  }

  addToProduction = (e) => {
    e.preventDefault();
    let exercises = [];
    this.state.checked.forEach(id => {
      exercises.push(this.state.exercisesAll.find(exercise => exercise._id === id));
    })

    this.setState({
      ...this.initState
    })
    if(exercises.length > 0) {
      this.props.saveExerciseMappingToProd(exercises);
    }
  }

  render() {
    return (
      <div>
        <div className="inline">
          <div className="motivation-div">
            <h2 className="headline">Exercises</h2>
            <div style={{display: "inline-flex"}}>
            <input type="text" placeholder="Search"  name="search" value={this.state.search} onChange={this.handleChange} className="select-motivation search-input search-exercises"/>
              {
                process.env.REACT_APP_ENVIRONMENT !== 'production'  ?
                  <button onClick={this.addToProduction} className="addButton final-btn final-btn-feedback">Add To Production</button>
                : null
              }
              <button onClick={this.deleteExercises} className="addButton  final-btn-feedback"> Delete </button>
            </div>
            <div className="specific-feedbacks-head inline-row inline-row-motivation">
            <div className="column column-checkbox" style={{border: 'none'}} ></div>
              <div className="column-motivation column-head">Exercise Present Name</div>
            </div>
            <div className="specific-feedbacks">
              <div className="names">{this.renderExercises()}</div>
            </div>
          </div>
            <form onSubmit={this.submitForm} className="add-form"> 
              <div style={{display: 'grid'}}>
              <input  className="select-motivation input-motivation"  name="present_name" type="text" 
                value={this.state.present_name} onChange={this.handleChange} placeholder="Present Name"/>
              <input  className="select-motivation input-motivation"  name="name" type="text" 
                value={this.state.name} onChange={this.handleChange} placeholder="Name"/>
              <select className="select-motivation input-motivation"  name="type" type="text" 
                value={this.state.type} onChange={this.handleChange}>
                <option>Select Type</option>
                <option value={"TIME"}>TIME</option>
                <option value={"TIME_AND_REPS"}>TIME AND REPS</option>
              </select>
              <select className="select-motivation input-motivation"  name="difficulty" type="text" 
                value={this.state.difficulty} onChange={this.handleChange}>
                <option>Select difficulty</option>
                <option value={"hard"}>hard</option>
                <option value={"medium"}>medium</option>
                <option value={"light"}>light</option>
              </select>
              <select className="select-motivation input-motivation"  name="front" type="text" 
                value={this.state.front} onChange={this.handleChange}>
                <option>Select Front</option>
                <option value={"TRAINER"}>TRAINER</option>
                <option value={"TRAINEE"}>TRAINEE</option>
              </select>
              <select className="select-motivation input-motivation"  name="skeleton" type="text" 
                value={this.state.skeleton} onChange={this.handleChange}>
                <option>Select Skeleton</option>
                <option value={true}>True</option>
                <option value={false}>False</option>
              </select>
              <select className="select-motivation input-motivation"  name="bars" type="text" 
                value={this.state.bars} onChange={this.handleChange}>
                <option>Select Bars</option>
                <option value={true}>True</option>
                <option value={false}>False</option>
              </select>
              <select className="select-motivation input-motivation"  name="score" type="text" 
                value={this.state.score} onChange={this.handleChange}>
                <option>Select Score</option>
                <option value={true}>True</option>
                <option value={false}>False</option>
              </select>
              <input className="select-motivation input-motivation"  name="intro" type="text" 
                value={this.state.instructions.intro} onChange={this.handleChange} placeholder="Instructions Intro"/>
              <input className="select-motivation input-motivation"  name="trainer_tips" type="text" 
                value={this.state.instructions.trainer_tips} onChange={this.handleChange} placeholder="Instructions Trainer Tips"/>
              </div>
              
              <button type="submit" className="savebtn" onClick={this.submitForm}>Save</button> 
            </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    exerciseMapping: state.workout.exerciseMapping,
    updateExerciseMapping: state.workout.saveExerciseMapping,
    deleteExercises: state.workout.deleteExerciseMapping
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ getExerciseMapping, saveExerciseMapping, deleteExercisesMapping, saveExerciseMappingToProd },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Exercise);